import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppConfigService } from 'src/app/config/app-config.service';
import { AppConfig } from '../../../config/app-config';
@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private appInsights: ApplicationInsights;
  private appConfig: AppConfig;

  constructor(appConfigService: AppConfigService) {
    this.appConfig = appConfigService.getConfig();

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.appConfig.applicationInsightsFrontend.instrumentationKeyFrontend,
        enableAutoRouteTracking: true, // option to log all route changes
        enableCorsCorrelation: true,
      },
    });
  }

  initialize() {
    this.appInsights.loadAppInsights();

    this.appInsights.addTelemetryInitializer(envelope => {
      envelope.tags['ai.cloud.role'] = this.appConfig.applicationInsightsFrontend.roleNameFrontend;
    });
  }
}
